import InitialState from "./CompanyRedux";
import { createSlice } from "@reduxjs/toolkit";

const initialState: InitialState = {};

export const CompanySlice = createSlice({
  name: "CompanySlice",
  initialState: initialState,
  reducers: {},
});

// Action creators are generated for each case reducer function
// You must export the reducer as follows for it to be able to be read by the store.
export default CompanySlice.reducer;
